import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { routing } from './app.routing';

import HelloWorldComponent from './helloWorld/helloWorld.component';
import NavigationComponent from './navigation/navigation.component';
import NavigationWorkOrdersComponent from './navigationWorkOrders/navigationWorkOrders.component';
import { NavigationInternalComponent } from './navigationInternal/navigationInternal.component';
import { LoginComponent } from './login/login.component';
import { LoginHeaderComponent } from './loginHeader/loginHeader.component';
import { FooterComponent } from './footer/footer.component';
import { ChangePasswordComponent } from './changePassword/changePassword.component';
import { ForgotPasswordComponent } from './forgotPassword/forgotPassword.component';
import { ExitComponent } from './exit/exit.component';
import { SpecialAdmittedComponent } from './specialAdmitted/specialAdmitted.component';
import { SpecialInstructionComponent } from './specialInstruction/specialInstruction.component';
import { SpecialResearchComponent } from './specialResearch/specialResearch.component';
import { SortTaskListComponent } from './sortTaskList/sortTaskList.component';
import { SortTaskListHelpComponent } from './sortTaskListHelp/sortTaskListHelp.component';
import OffenseComponent from './offense/offense.component';
import OffenseCountsComponent from './offenseCounts/offenseCounts.component';
import OffenseRecordComponent from './offenseRecord/offenseRecord.component';
import OffenseSearchComponent from './offenseSearch/offenseSearch.component';
import OffenseHelpComponent from './offenseHelp/offenseHelp.component';
import RegistrationComponent from './registration/registration.component';
import { ResearcherTaskCommentComponent } from './researcherTaskComment/researcherTaskComment.component';
import { ResearcherTaskListComponent } from './researcherTaskList/researcherTaskList.component';
import { ResearcherTaskListHelpComponent } from './researcherTaskListHelp/researcherTaskListHelp.component';
import { WorkOrderReportComponent } from './workOrderReport/workOrderReport.component';
import { WorkOrderIdentifiersComponent } from './workOrderIdentifiers/workOrderIdentifiers.component';
import { WorkOrderAdmissionsComponent } from './workOrderAdmissions/workOrderAdmissions.component';
import { WorkOrderSpecialInstructionsComponent } from './workOrderSpecialInstructions/workOrderSpecialInstructions.component';
import ConfirmationComponent from './confirmation/confirmation.component';
import ReportsComponent from './reports/reports.component';
import InvoiceReportComponent from './invoiceReport/invoiceReport.component';
import { OrderBy } from '../models/orderBy';

// providers
import { AuthenticationService } from '../services/index';
import EnvironmentService from '../services/environmentService';
import MessageService from '../services/messageService';
import BrowserWindowObjectService from '../services/browserWindowObjectService';
import ComplianceAuditLogService from '../services/complianceAuditLogService';

// guards
import AuthenticationGuard from '../guards/authenticationGuard';

// custom directives
import ValidateOnBlurDirective from '../directives/validateOnblur.directive';


@NgModule({
  declarations: [
    AppComponent,
    HelloWorldComponent,
    LoginComponent,
    LoginHeaderComponent,
    FooterComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    ExitComponent,
    ResearcherTaskListComponent,
    ResearcherTaskCommentComponent,
    SpecialInstructionComponent,
    SpecialAdmittedComponent,
    SpecialResearchComponent,
    SortTaskListComponent,
    SortTaskListHelpComponent,
    WorkOrderReportComponent,
    WorkOrderIdentifiersComponent,
    WorkOrderAdmissionsComponent,
    WorkOrderSpecialInstructionsComponent,
    OffenseComponent,
    OffenseSearchComponent,
    OffenseRecordComponent,
    OffenseCountsComponent,
    OffenseHelpComponent,
    NavigationComponent,
    NavigationWorkOrdersComponent,
    NavigationInternalComponent,
    LoginComponent,
    RegistrationComponent,
    ConfirmationComponent,
    ValidateOnBlurDirective,
    ResearcherTaskListHelpComponent,
    ReportsComponent,
    InvoiceReportComponent,
    ValidateOnBlurDirective,
    OrderBy
  ],
  imports: [
    BrowserModule,
    HttpModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
  ],

  providers: [AuthenticationGuard,
    AuthenticationService,
    MessageService, EnvironmentService,
    BrowserWindowObjectService,
    ComplianceAuditLogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts